/**
 * Replace original attributes in the original array with the replaced ones
 * @param {Array<String>} original
 * @param {Map<String, Map<String, Array<String>>>} replaced
 * @returns {Array<String>}
 */
const replaceOriginalAttributes = (original, replaced) => {
  /** Final, returned array with replaced aliases */
  const result = [];

  for (const attribute of original) {
    if (replaced.has(attribute)) {
      const initials = /** @type {Array<String>} */ (
        replaced?.get(attribute)?.get("initials")
      );
      const results = /** @type {Array<String>} */ (
        replaced?.get(attribute)?.get("result")
      );

      if (initials?.length) {
        for (const initial of initials) {
          if (initial) {
            result.push(initial);
          }
        }
      }

      for (const item of results) {
        result.push(item);
      }
    } else {
      result.push(attribute)
    }
  }

  return result;
};

export default replaceOriginalAttributes;
